module.exports = __webpack_public_path__ + "assets/img/guide-arrow.c77e827d.png";